<!-- paypal-settings.component.html -->
<div class="container">
  <br/>
  <h5><i class="fas fa-wallet"></i> PayPal Settings</h5>

  
    <form [formGroup]="paypalForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="clientId">Client ID</label>
        <input id="clientId" formControlName="clientId" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="clientSecret">Client Secret</label>
        <input id="clientSecret" formControlName="clientSecret" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="mode">Mode (sandbox/live)</label>
        <input id="mode" formControlName="mode" class="form-control" />
      </div>
  
      <button type="submit" class="btn btn-outline-primary" [disabled]="!paypalForm.valid">
        Update
      </button>
    </form>
  
    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-outline-success mt-2">
      {{ successMessage }}
    </div>
  
    <!-- Error Message -->
    <!-- <div *ngIf="errorMessage" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div> -->
</div>
